var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("article", { staticClass: "catalog-item trs" }, [
    _c(
      "a",
      {
        staticClass: "catalog-item__top clr-blue-7 t-tdn",
        attrs: { href: _vm.item.url },
      },
      [
        _c("div", { staticClass: "media-obj catalog-item__img" }, [
          _c("picture", [
            _c("img", { attrs: { src: _vm.item.image, alt: "" } }),
          ]),
        ]),
        _c("h3", { staticClass: "t-h3 catalog-item__title" }, [
          _vm._v(_vm._s(_vm.item.title)),
        ]),
        _c("p", {
          staticClass: "t-md catalog-item__description",
          domProps: { innerHTML: _vm._s(_vm.item.description) },
        }),
      ]
    ),
    _c("div", { staticClass: "catalog-item__bottom" }, [
      _vm.item.price > 0
        ? _c("span", { staticClass: "catalog-item__price" }, [
            _c("span", { staticClass: "clr-grey-4" }, [_vm._v("Цена")]),
            _c("span", { staticClass: "clr-blue-6 trs" }, [
              _vm._v("'" + _vm._s(_vm.item.price) + "'"),
            ]),
          ])
        : _vm._e(),
      _vm.item.price <= 0
        ? _c(
            "button",
            {
              staticClass: "catalog-item__price",
              on: { click: _vm.showModal },
            },
            [
              _c("span", { staticClass: "clr-grey-4" }, [_vm._v("Цена")]),
              _c("span", { staticClass: "clr-blue-6 trs" }, [
                _vm._v("По запросу"),
              ]),
            ]
          )
        : _vm._e(),
      !_vm.inCompare
        ? _c(
            "button",
            {
              staticClass: "catalog-item__btn clr-grey-4 trs",
              attrs: { type: "button" },
              on: { click: _vm.addToCompare },
            },
            [_vm._v("Сравнить")]
          )
        : _vm._e(),
      _vm.inCompare
        ? _c(
            "a",
            {
              staticClass:
                "catalog-item__btn clr-grey-4 trs catalog-item__in-compare",
              attrs: { type: "button", href: "/compare/" },
            },
            [_vm._v("В сравнении")]
          )
        : _vm._e(),
      _c("div", { staticClass: "catalog-item__cart-buttons-wraper" }, [
        !_vm.inBasket
          ? _c(
              "button",
              {
                staticClass: "icon-btn t-tdn trs catalog-item__cart",
                on: { click: _vm.addToBasket },
              },
              [
                _vm._v("В корзину"),
                _c("span", { staticClass: "media-obj" }, [
                  _c(
                    "svg",
                    { attrs: { xmlns: "http://www.w3.org/2000/svg" } },
                    [
                      _c("use", {
                        attrs: {
                          href: "/local/templates/renaissance/layout/dist/assets/img/sprite.svg#i-list",
                        },
                      }),
                    ]
                  ),
                ]),
              ]
            )
          : _vm._e(),
        _vm.inBasket
          ? _c(
              "button",
              {
                staticClass:
                  "icon-btn t-tdn trs catalog-item__cart catalog-item__cart_inbasket",
                attrs: { title: "В корзине" },
              },
              [
                _vm._v("В корзине"),
                _c("span", { staticClass: "media-obj" }, [
                  _c(
                    "svg",
                    { attrs: { xmlns: "http://www.w3.org/2000/svg" } },
                    [
                      _c("use", {
                        attrs: {
                          href: "/local/templates/renaissance/layout/dist/assets/img/sprite.svg#i-list",
                        },
                      }),
                    ]
                  ),
                ]),
              ]
            )
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }